module.exports = __webpack_public_path__ + "static/wand_of_web-7baee27c9bf437fa70e8d30b0f456a9b.jpeg";